import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { connect } from 'react-redux';
import { ModuleRegistry } from 'ag-grid-community';
import { CheckboxEditorModule } from 'ag-grid-community';
import { Button, Input, Form, FormGroup, Label, Table } from 'reactstrap';
import moment from 'moment';

class IndiSaltoIndiv extends Component {
    static displayName = IndiSaltoIndiv.name;

    constructor(props) {
        super(props);
        var thisDate = new Date()
        var now = moment(thisDate).format('YYYY-MM-DD')
        this.state = {
            bearerVAR: "Bearer " + this.props.reduxData.apiKey,
            tableData: [],
            formActive: { pcid: "DEFAULT", salto: "DEFAULT", expdate: now },
            formData: { namelist: [], saltolist: [] },
            updateCounter: 1
        }
        //this.getTableData();
        this.apiFetch("IndiSaltoIndivGetTable", {}, "tableData")
        this.apiFetch("IndiSaltoIndivGetForm", {}, "formData")
    }

    async apiFetch(url,body,stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            [stateItem]: data
        })
        //return data
    }

    //async getTableData() {
    //    this.props.updateFetchTime()
    //    let toSend = {
    //        userLevel: this.props.reduxData.userInfo.level.pk,
            
    //    }
    //    const response = await fetch("IndiSaltoIndivGetTable", {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
    //        body: JSON.stringify(toSend)
    //    })
    //    const data = await response.json()
    //    this.setState({
    //        tableData: data
    //    })
    //}

    formUpdate(data, target) {
        let newFormData = {}
        switch (target) {
            case "pcid":
                newFormData = {
                    ...this.state.formActive,
                    pcid: data
                }
                break;
            case "salto":
                newFormData = {
                    ...this.state.formActive,
                    salto: data
                }
                break;
            case "expdate":
                newFormData = {
                    ...this.state.formActive,
                    expdate: data
                }
                break;
            default:
                break;
        }
        console.log("newFormData:", newFormData)
        this.setState({
            formActive: newFormData
        })
    }

    async getFormData() {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,

        }
        const response = await fetch("IndiSaltoIndivGetTable", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.state.bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            tableData: data
        })
    }

    async submitButton() {
        console.log("formActive: ", this.state.formActive)
        this.apiFetch("IndiSaltoIndivSubmit", { pcid: this.state.formActive.pcid, salto: this.state.formActive.salto, expdate: this.state.formActive.expdate }, "tableData")
            
    }

    async deleteButton(pk) {
        this.apiFetch("IndiSaltoIndivDelete", { todelete: pk }, "tableData")
            
    }

    render() {
        return (<div>
            <h3>Individual</h3>
            <br />
            <Form className="d-flex">
                <FormGroup>
                    <Input type="select" id="indipcid" name="indipcid" value={this.state.formActive.pcid} onChange={(e) => this.formUpdate(e.target.value,"pcid")}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.formData.namelist.map(item => (
                            <option value={item.pcid}>{item.name}</option>
                        ))}
                    </Input>
                    <Label>PCID</Label>
                </FormGroup>
                &ensp;
                <FormGroup>
                    <Input type="select" id="indisalto" name="indisalto" value={this.state.formActive.salto} onChange={(e) => this.formUpdate(e.target.value, "salto")}>
                        <option value="DEFAULT" disabled>Select</option>
                        {this.state.formData.saltolist.map(item => (
                            <option>{item}</option>
                        )) }
                    </Input>
                    <Label>Salto Group</Label>
                </FormGroup>
                &ensp;
                <FormGroup>
                    <Input type="date" id="indiexp" name="indiexp" value={this.state.formActive.expdate} onChange={(e) => this.formUpdate(e.target.value, "expdate")} />
                    <Label>Expiration Date</Label>
                </FormGroup>
                &ensp;
                <Button color="success" onClick={() => this.submitButton() }>Submit</Button>
            </Form>
            <br />
            <span style={{ color: 'red' }}>Please note that all records must have an expiration date <strong>within six months of submission.</strong> Any records with an expiration date greater than six months from now will be updated automatically to reflect this requirement.</span>
            <br />
            <Table>
                <thead>
                    <tr>
                        <th>PCID</th>
                        <th>Name</th>
                        <th>Salto Group</th>
                        <th>Expiration Date</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.tableData.map(item => (
                        <tr>
                            <td>{item.pcid}</td>
                            <td>{item.name}</td>
                            <td>{item.saltogroup}</td>
                            <td>{item.expdate.substring(0,item.expdate.indexOf(" "))}</td>
                            <td><Button onClick={() => this.deleteButton(item.pk)}>Delete</Button></td>
                        </tr>
                    )) }
                </tbody>
            </Table>
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(IndiSaltoIndiv);